import { render, staticRenderFns } from "./dili.vue?vue&type=template&id=e9a014c0&scoped=true&"
import script from "./dili.vue?vue&type=script&lang=js&"
export * from "./dili.vue?vue&type=script&lang=js&"
import style0 from "./dili.vue?vue&type=style&index=0&id=e9a014c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a014c0",
  null
  
)

export default component.exports